import { Text, useTheme } from "native-base";
import React from "react";
import { Platform, TextStyle } from "react-native";

interface ShimmerTextProps {
  children: React.ReactNode;
  fontSize?: string | number;
  color?: string;
  textAlign?: "center" | "left" | "right";
  fontStyle?: "normal" | "italic";
}

const ShimmerText: React.FC<ShimmerTextProps> = ({
  children,
  fontSize = "lg",
  color = "function.40",
  textAlign = "center",
  fontStyle = "normal",
}) => {
  const theme = useTheme();
  // Apply shimmer effect only on web platform
  const webStyle = Platform.select({
    web: {
      background: `linear-gradient(
        90deg,
        currentColor 0%,
        currentColor 40%,
        rgba(255, 255, 255, 0.3) 50%,
        currentColor 60%,
        currentColor 100%
      )`,
      backgroundSize: "200% 100%",
      backgroundClip: "text",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      animation: "shimmer 4s ease-in-out infinite",
    } as TextStyle & Record<string, string>,
    default: {} as TextStyle,
  });

  return (
    <>
      {Platform.OS === "web" && (
        <style
          dangerouslySetInnerHTML={{
            __html: `
            @keyframes shimmer {
              0% {
                background-position: 200% 0;
              }
              100% {
                background-position: -200% 0;
              }
            }
          `,
          }}
        />
      )}
      <Text fontSize={fontSize} color={color} textAlign={textAlign} fontStyle={fontStyle} style={webStyle}>
        {children}
      </Text>
    </>
  );
};

export default ShimmerText;
